/* =========================================================
   STAR2GO theme — interações (header/footer/ícones são Liquid)
   ========================================================= */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---------- Menu mobile ---------- */
  function setupMobileMenu() {
    var burger = document.querySelector("[data-burger]");
    var menu = document.getElementById("MobileMenu");
    if (!burger || !menu) return;
    function setOpen(open) {
      menu.classList.toggle("open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      menu.setAttribute("aria-hidden", open ? "false" : "true");
      // menu-open trava o scroll E esconde as barras fixas do rodapé (minibar/pdp-addbar)
      // que, sendo fixed, pintariam por cima do menu full-screen.
      document.body.classList.toggle("no-scroll", open);
      document.body.classList.toggle("menu-open", open);
    }
    burger.addEventListener("click", function () { setOpen(!menu.classList.contains("open")); });
    menu.addEventListener("click", function (e) {
      if (e.target.closest("a") || e.target.closest("[data-mm-close]")) setOpen(false);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") setOpen(false); });
  }

  /* ---------- Posiciona o thumb do toggle ---------- */
  function positionThumb() {
    var t = document.getElementById("audToggle");
    if (!t) return;
    var thumb = t.querySelector(".thumb");
    var active = t.querySelector("a.is-active");
    if (!active || !thumb) return;
    thumb.style.left = active.offsetLeft + "px";
    thumb.style.width = active.offsetWidth + "px";
  }

  /* ---------- Toggle de público ---------- */
  function setupAudienceToggle() {
    var t = document.getElementById("audToggle");
    if (!t) return;
    // O toggle posiciona o indicador visual; os <a> navegam normalmente
    // para as páginas Consumidor / Empresarial (sem troca no lugar).
    requestAnimationFrame(positionThumb);
    window.addEventListener("resize", positionThumb);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(positionThumb);
  }

  function setHomeMode(mode) {
    document.body.dataset.mode = mode;
    var t = document.getElementById("audToggle");
    if (t) {
      t.querySelectorAll("a").forEach(function (a) {
        a.classList.toggle("is-active", a.dataset.mode === mode);
      });
      positionThumb();
    }
    document.querySelectorAll("[data-hero]").forEach(function (el) {
      el.hidden = el.dataset.hero !== mode;
    });
    document.querySelectorAll("[data-cta-b2c]").forEach(function (el) {
      el.hidden = mode !== "b2c";
    });
    document.querySelectorAll("[data-cta-b2b]").forEach(function (el) {
      el.hidden = mode !== "b2b";
    });
    try { localStorage.setItem("s2g-mode", mode); } catch (e) {}
  }

  /* ---------- Reveal ao rolar ---------- */
  function setupReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;
    // Sem IntersectionObserver: deixa visível (não "arma" o hide).
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.remove("armed"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    // "arma" o hide só agora que o JS rodou; se o JS falhar, conteúdo aparece.
    els.forEach(function (e) { e.classList.add("armed"); io.observe(e); });
  }

  /* ---------- Mensagem de sucesso do formulário de orçamento ---------- */
  function setupQuoteForm() {
    // Sucesso é renderizado pelo Liquid (form.posted_successfully?); só rolamos até ele.
    var ok = document.getElementById("formSuccess");
    if (ok) ok.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  /* ---------- Header comprime ao rolar ---------- */
  function setupHeaderCompress() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle("is-compact", (window.scrollY || window.pageYOffset) > 60);
        ticking = false;
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Busca preditiva (Section Rendering API + Search & Discovery) ---------- */
  function setupPredictiveSearch() {
    document.querySelectorAll("[data-predictive-search]").forEach(function (form) {
      var input = form.querySelector('input[name="q"]');
      var box = form.querySelector("[data-predictive-results]");
      if (!input || !box) return;
      var timer, lastQ = "";

      function close() { box.hidden = true; input.setAttribute("aria-expanded", "false"); }
      function open() { if (box.innerHTML.trim()) { box.hidden = false; input.setAttribute("aria-expanded", "true"); } }

      function run(q) {
        if (q === lastQ) { open(); return; }
        lastQ = q;
        var url = "/search/suggest?q=" + encodeURIComponent(q) +
          "&section_id=predictive-search" +
          "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
        fetch(url, { headers: { "Accept": "text/html" } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement("div");
            tmp.innerHTML = html;
            var inner = tmp.querySelector(".predictive-inner");
            box.innerHTML = inner ? inner.innerHTML : "";
            open();
          })
          .catch(close);
      }

      input.addEventListener("input", function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); lastQ = ""; return; }
        timer = setTimeout(function () { run(q); }, 220);
      });
      input.addEventListener("focus", function () {
        if (input.value.trim().length >= 2) open();
      });
      input.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { close(); input.blur(); }
      });
      document.addEventListener("click", function (e) {
        if (!form.contains(e.target)) close();
      });
    });
  }

  /* ---------- Carrinho: add AJAX + drawer + upsell ---------- */
  function setupCart() {
    var drawer = document.getElementById("CartDrawer");
    var overlay = document.querySelector("[data-drawer-overlay]");
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add("open");
      if (overlay) overlay.classList.add("open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("no-scroll");
      loadUpsell();
    }
    function closeDrawer() {
      drawer.classList.remove("open");
      if (overlay) overlay.classList.remove("open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.classList.remove("no-scroll");
    }
    function updateCount(n) {
      document.querySelectorAll(".cart-count").forEach(function (el) {
        el.textContent = n; el.setAttribute("data-count", n);
      });
    }
    function post(url, body, el) {
      if (el) el.classList.add("is-loading");
      return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); })
        .then(function (data) { if (el) el.classList.remove("is-loading"); return data; })
        .catch(function (e) { if (el) el.classList.remove("is-loading"); throw e; });
    }
    function applySections(sections) {
      if (!sections || !sections["cart-drawer"]) return;
      var tmp = document.createElement("div");
      tmp.innerHTML = sections["cart-drawer"];
      var fresh = tmp.querySelector("#CartDrawer");
      if (fresh) {
        drawer.innerHTML = fresh.innerHTML;
        drawer.setAttribute("data-cart-count", fresh.getAttribute("data-cart-count") || "0");
        drawer.setAttribute("data-cart-products", fresh.getAttribute("data-cart-products") || "");
        updateCount(fresh.getAttribute("data-cart-count") || "0");
      }
      // atualiza a barra minimizada (mobile)
      var freshBar = tmp.querySelector("#CartMinibar");
      var curBar = document.getElementById("CartMinibar");
      if (freshBar && curBar) { curBar.innerHTML = freshBar.innerHTML; curBar.className = freshBar.className; }
    }
    function addVariant(id, qty, el) {
      post("/cart/add.js", { items: [{ id: id, quantity: qty || 1 }], sections: ["cart-drawer"], sections_url: location.pathname }, el)
        .then(function (data) {
          if (data && data.status && data.status >= 400) { alert(data.description || "Não foi possível adicionar ao carrinho."); return; }
          // precisa do estado atualizado do drawer
          return refresh().then(openDrawer);
        }).catch(function () {});
    }
    function changeLine(key, qty, el) {
      post("/cart/change.js", { id: key, quantity: qty, sections: ["cart-drawer"], sections_url: location.pathname }, el)
        .then(function (data) { applySections(data.sections); loadUpsell(); }).catch(function () {});
    }
    function refresh() {
      return fetch("/?section_id=cart-drawer").then(function (r) { return r.text(); })
        .then(function (html) { applySections({ "cart-drawer": html }); });
    }
    function loadUpsell() {
      var products = (drawer.getAttribute("data-cart-products") || "").split(",").filter(Boolean);
      var upsell = drawer.querySelector("[data-upsell]");
      var row = drawer.querySelector("[data-upsell-row]");
      if (!products.length || !upsell || !row) return;
      var pid = products[0];
      recs(pid, "complementary").then(function (html) {
        if (html && html.trim()) return html;
        return recs(pid, "related");
      }).then(function (html) {
        if (html && html.trim()) { row.innerHTML = html; upsell.hidden = false; }
      });
    }
    function recs(id, intent) {
      return fetch("/recommendations/products?section_id=cart-recommendations&product_id=" + id + "&intent=" + intent + "&limit=6")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var t = document.createElement("div"); t.innerHTML = html;
          var w = t.querySelector(".shopify-section") || t;
          return w.innerHTML;
        }).catch(function () { return ""; });
    }

    document.addEventListener("click", function (e) {
      var toggle = e.target.closest("[data-cart-toggle]");
      if (toggle) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest("[data-cart-close]") || e.target.closest("[data-drawer-overlay]")) { e.preventDefault(); closeDrawer(); return; }
      var qc = e.target.closest("[data-qty-change]");
      if (qc) { e.preventDefault(); changeLine(qc.getAttribute("data-qty-change"), parseInt(qc.getAttribute("data-qty"), 10), qc); return; }
      var add = e.target.closest("[data-add-variant]");
      if (add) { e.preventDefault(); addVariant(add.getAttribute("data-add-variant"), 1, add); return; }
    });
    document.addEventListener("submit", function (e) {
      var form = e.target.closest && e.target.closest("form.product-form");
      if (!form) return;
      // nunca sequestrar o checkout dinâmico da Shopify (Comprar agora posta sozinho)
      if (e.submitter && e.submitter.closest(".shopify-payment-button")) return;
      e.preventDefault();
      var idEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      if (!idEl || !idEl.value) { form.submit(); return; }
      addVariant(idEl.value, qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1, form.querySelector('[type="submit"]'));
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });
  }

  /* ---------- Galeria do produto (carrossel + thumbs) ---------- */
  function setupGallery() {
    document.querySelectorAll("[data-pdp-gallery]").forEach(function (g) {
      var stage = g.querySelector("[data-pdp-stage]");
      if (!stage) return;
      var slides = stage.querySelectorAll(".pdp-slide");
      if (slides.length < 2) return;
      var thumbs = g.querySelectorAll("[data-pdp-thumb]");
      var dots = g.querySelectorAll("[data-pdp-dot]");
      function goTo(i) { stage.scrollTo({ left: i * stage.clientWidth, behavior: "smooth" }); }
      function current() { return Math.round(stage.scrollLeft / stage.clientWidth); }
      thumbs.forEach(function (t) { t.addEventListener("click", function () { goTo(parseInt(t.getAttribute("data-pdp-thumb"), 10)); }); });
      dots.forEach(function (d) { d.addEventListener("click", function () { goTo(parseInt(d.getAttribute("data-pdp-dot"), 10)); }); });
      var prev = g.querySelector("[data-pdp-prev]"), next = g.querySelector("[data-pdp-next]");
      if (prev) prev.addEventListener("click", function () { goTo(Math.max(0, current() - 1)); });
      if (next) next.addEventListener("click", function () { goTo(Math.min(slides.length - 1, current() + 1)); });

      // Troca a imagem ao escolher a variante (data-img na <option> + data-media-id no slide)
      var vsel = document.querySelector('.product-form select[name="id"]');
      if (vsel) {
        var toVariantImg = function (imgId, instant) {
          if (!imgId) return;
          var idx = -1;
          slides.forEach(function (s, k) { if (String(s.getAttribute("data-media-id")) === String(imgId)) idx = k; });
          if (idx >= 0) stage.scrollTo({ left: idx * stage.clientWidth, behavior: instant ? "auto" : "smooth" });
        };
        vsel.addEventListener("change", function () {
          var o = vsel.options[vsel.selectedIndex];
          toVariantImg(o && o.getAttribute("data-img"));
        });
        var o0 = vsel.options[vsel.selectedIndex];
        if (o0) toVariantImg(o0.getAttribute("data-img"), true);
      }

      var t;
      stage.addEventListener("scroll", function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = current();
          thumbs.forEach(function (x, k) { x.classList.toggle("is-active", k === i); });
          dots.forEach(function (x, k) { x.classList.toggle("is-active", k === i); });
          var counter = g.querySelector("[data-pdp-counter] b"); if (counter) counter.textContent = i + 1;
        }, 60);
      }, { passive: true });
    });
  }

  /* ---------- PDP: barra fixa "Adicionar ao carrinho" ---------- */
  function setupPdpAddbar() {
    var bar = document.querySelector("[data-pdp-addbar]");
    var form = document.querySelector("form.product-form");
    if (!bar || !form) return;
    var inlineBtn = form.querySelector('[type="submit"]');
    if ("IntersectionObserver" in window && inlineBtn) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle("show", !en.isIntersecting); });
      }, { threshold: 0 });
      io.observe(inlineBtn);
    } else {
      bar.classList.add("show");
    }
    var addBtn = bar.querySelector("[data-pdp-add]");
    if (addBtn) addBtn.addEventListener("click", function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  }

  /* ---------- PDP: bottom-sheet de opções (seta da barra) ---------- */
  function setupPdpOptions() {
    var sheet = document.getElementById("PdpOptions");
    if (!sheet) return;
    var overlay = document.querySelector("[data-drawer-overlay]");
    function open() {
      sheet.classList.add("open"); sheet.setAttribute("aria-hidden", "false");
      if (overlay) overlay.classList.add("open");
      document.body.classList.add("no-scroll");
    }
    function close() {
      sheet.classList.remove("open"); sheet.setAttribute("aria-hidden", "true");
      var cart = document.getElementById("CartDrawer");
      if (!cart || !cart.classList.contains("open")) {
        if (overlay) overlay.classList.remove("open");
        document.body.classList.remove("no-scroll");
      }
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-pdp-options]")) { e.preventDefault(); open(); return; }
      if (e.target.closest("[data-pdp-options-close]") || e.target.closest("[data-drawer-overlay]")) { close(); }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* ---------- Hotspots (shoppable image + image-with-text) ---------- */
  function hsCloseAll(except) {
    document.querySelectorAll(".hotspot.is-open").forEach(function (h) {
      if (h === except) return;
      h.classList.remove("is-open");
      var d = h.querySelector(".hotspot__dot"); if (d) d.setAttribute("aria-expanded", "false");
      var p = h.querySelector(".hotspot__popup"); if (p) p.hidden = true;
    });
  }
  function hsOpen(h) {
    hsCloseAll(h);
    var parent = h.offsetParent || h.parentElement;
    if (parent) {
      var cr = parent.getBoundingClientRect(), dr = h.getBoundingClientRect();
      var cx = (dr.left + dr.width / 2 - cr.left) / cr.width;
      var cy = (dr.top + dr.height / 2 - cr.top) / cr.height;
      h.classList.toggle("is-flip-x", cx > 0.6);
      h.classList.toggle("is-flip-x-left", cx < 0.4);
      h.classList.toggle("is-flip-y", cy > 0.55);
    }
    h.classList.add("is-open");
    var d = h.querySelector(".hotspot__dot"); if (d) d.setAttribute("aria-expanded", "true");
    var p = h.querySelector(".hotspot__popup");
    if (p) { p.hidden = false; p.querySelectorAll(".reveal.armed").forEach(function (r) { r.classList.remove("armed"); }); }
  }
  var hotspotsBound = false;
  function setupHotspots() {
    if (!document.querySelector("[data-hotspots]")) return;
    // hover (desktop, fine pointer) — per element, guarded against duplicates
    if (window.matchMedia("(hover:hover) and (pointer:fine)").matches) {
      document.querySelectorAll('[data-hotspots][data-trigger="hover"] .hotspot').forEach(function (h) {
        if (h.__hsHover) return; h.__hsHover = true;
        h.addEventListener("mouseenter", function () { hsOpen(h); });
        h.addEventListener("mouseleave", function () { hsCloseAll(); });
      });
    }
    if (hotspotsBound) return;
    hotspotsBound = true;
    document.addEventListener("click", function (e) {
      var dot = e.target.closest(".hotspot__dot");
      if (dot) {
        var h = dot.closest(".hotspot");
        e.preventDefault();
        if (h.classList.contains("is-open")) hsCloseAll(); else hsOpen(h);
        return;
      }
      if (!e.target.closest(".hotspot__popup")) hsCloseAll();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") hsCloseAll(); });
  }

  /* ---------- Coleção + imagem: carrossel mobile ---------- */
  function setupCollectionImageCarousel() {
    document.querySelectorAll("[data-ci-carousel]").forEach(function (track) {
      if (track.__ciInit) return; track.__ciInit = true;
      var wrap = track.closest(".ci-panel") || track.parentElement;
      var dots = wrap.querySelectorAll("[data-ci-dots] .ci-dot");
      var slides = track.querySelectorAll(".ci-slide");
      if (!dots.length || slides.length < 2) return;
      var t;
      track.addEventListener("scroll", function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var stride = slides[1].offsetLeft - slides[0].offsetLeft || track.clientWidth;
          var i = Math.round(track.scrollLeft / stride);
          if (i < 0) i = 0; if (i >= dots.length) i = dots.length - 1;
          dots.forEach(function (d, k) { d.classList.toggle("is-active", k === i); });
        }, 60);
      }, { passive: true });
    });
  }

  /* ---------- Barra de avisos ---------- */
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function startCountdown(el) {
    var raw = (el.getAttribute("data-countdown-end") || "").trim().replace(" ", "T");
    if (raw && !/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) { raw += "-03:00"; } // horário de Brasília
    var end = new Date(raw).getTime();
    var endText = el.getAttribute("data-countdown-text") || "";
    if (isNaN(end)) { el.textContent = ""; return; }
    var id;
    function tick() {
      var diff = end - new Date().getTime();
      if (diff <= 0) { el.textContent = endText; if (id) clearInterval(id); return; }
      var d = Math.floor(diff / 86400000);
      var hh = Math.floor((diff % 86400000) / 3600000);
      var mm = Math.floor((diff % 3600000) / 60000);
      var ss = Math.floor((diff % 60000) / 1000);
      el.textContent = (d > 0 ? d + "d " : "") + pad(hh) + ":" + pad(mm) + ":" + pad(ss);
    }
    tick(); id = setInterval(tick, 1000);
  }
  function setupAnnouncementBar() {
    document.querySelectorAll("[data-announce]").forEach(function (bar) {
      if (bar.__announceInit) return; bar.__announceInit = true;
      var key = bar.getAttribute("data-persist");
      var design = window.Shopify && window.Shopify.designMode;
      var closeBtn = bar.querySelector("[data-announce-close]");
      if (closeBtn) closeBtn.addEventListener("click", function () {
        bar.style.display = "none";
        if (!design) { try { localStorage.setItem(key, "1"); } catch (e) {} }
      });
      if (bar.getAttribute("data-rotation") === "fade") {
        var msgs = bar.querySelectorAll("[data-announce-msg]");
        var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches || document.body.classList.contains("anim-off");
        if (msgs.length > 1 && !reduce) {
          var speed = parseInt(bar.getAttribute("data-speed"), 10) || 5000;
          var idx = 0;
          setInterval(function () {
            msgs[idx].classList.remove("is-active"); msgs[idx].hidden = true;
            idx = (idx + 1) % msgs.length;
            msgs[idx].hidden = false; msgs[idx].classList.add("is-active");
          }, speed);
        }
      }
      bar.querySelectorAll("[data-countdown-end]").forEach(function (el) { startCountdown(el); });
    });
  }

  /* PDP: calcular frete por CEP — usa as tarifas do checkout (ex.: Frenet) via /cart/shipping_rates.json.
     A Shopify só calcula frete sobre o carrinho, então adiciona o item nos bastidores e restaura depois. */
  function setupShippingCalc() {
    var box = document.querySelector("[data-ship-calc]");
    if (!box || box.dataset.scInit) return;
    box.dataset.scInit = "1";
    var form = box.querySelector("[data-ship-form]");
    var cepIn = box.querySelector("[data-ship-cep]");
    var result = box.querySelector("[data-ship-result]");
    var pform = document.querySelector(".product-form");
    if (!form || !cepIn) return;

    cepIn.addEventListener("input", function () {
      var v = cepIn.value.replace(/\D/g, "").slice(0, 8);
      cepIn.value = v.length > 5 ? v.slice(0, 5) + "-" + v.slice(5) : v;
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var cep = cepIn.value.replace(/\D/g, "");
      if (cep.length !== 8) { result.innerHTML = '<p class="ship-calc__err">Digite um CEP válido (8 dígitos).</p>'; return; }
      var idEl = pform && pform.querySelector('[name="id"]');
      var qtyEl = pform && pform.querySelector('[name="quantity"]');
      var vid = idEl ? parseInt(idEl.value, 10) : 0;
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      if (!vid) { result.innerHTML = '<p class="ship-calc__err">Selecione uma opção do produto.</p>'; return; }
      result.innerHTML = '<p class="ship-calc__loading">Calculando frete…</p>';
      shipEstimate(vid, qty, cep, result);
    });
  }

  function shipEstimate(vid, qty, cep, result) {
    var orig = 0;
    var restore = function () {
      var u = {}; u[vid] = orig; // quantidade ABSOLUTA por id de variante (0 = remove o item temporário)
      return fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ updates: u }) });
    };
    var renderRates = function (rates) {
      if (!rates || !rates.length) { result.innerHTML = '<p class="ship-calc__err">Não encontramos opções de frete para esse CEP.</p>'; return; }
      var items = rates.map(function (rr) {
        var pv = parseFloat(rr.price);
        var price = (!pv) ? "Grátis" : "R$ " + pv.toFixed(2).replace(".", ",");
        var dd = (rr.delivery_days || []).filter(function (x) { return x != null && x !== ""; });
        var d = "";
        if (dd.length) {
          var mn = dd[0], mx = dd[dd.length - 1];
          var num = (mn === mx) ? String(mn) : (mn + "–" + mx);
          d = num + ((mn === mx && Number(mn) === 1) ? " dia útil" : " dias úteis");
        }
        return '<li><span class="ship-calc__name">' + rr.name + "</span>" + (d ? '<span class="ship-calc__days">' + d + "</span>" : "") + '<span class="ship-calc__price">' + price + "</span></li>";
      }).join("");
      result.innerHTML = '<ul class="ship-calc__list">' + items + '</ul><p class="ship-calc__note">Tempo estimado em transporte, após a preparação e envio do pedido.</p>';
    };
    // monta os parâmetros do endereço (CEP + país + UF/cidade do ViaCEP)
    var addrParams = function (prov, city) {
      var a = "shipping_address%5Bzip%5D=" + encodeURIComponent(cep) + "&shipping_address%5Bcountry%5D=Brazil";
      if (prov) a += "&shipping_address%5Bprovince%5D=" + encodeURIComponent(prov);
      if (city) a += "&shipping_address%5Bcity%5D=" + encodeURIComponent(city);
      return a;
    };
    // fluxo assíncrono oficial: prepara e faz poll até as tarifas ficarem prontas
    var poll = function (addr, tries) {
      return fetch("/cart/async_shipping_rates.json?" + addr, { headers: { Accept: "application/json" } })
        .then(function (r) { return r.status === 202 ? null : r.json(); })
        .then(function (d) {
          var rates = d && (d.shipping_rates || d.async_shipping_rates);
          if (rates) return rates;
          if (tries <= 0) return [];
          return new Promise(function (res) { setTimeout(res, 700); }).then(function () { return poll(addr, tries - 1); });
        });
    };

    fetch("https://viacep.com.br/ws/" + cep + "/json/", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; })
      .then(function (vc) {
        var prov = (vc && !vc.erro) ? (vc.uf || "") : "";
        var city = (vc && !vc.erro) ? (vc.localidade || "") : "";
        var addr = addrParams(prov, city);
        return fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            (cart.items || []).forEach(function (it) { if (it.id === vid) orig = it.quantity; });
            return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: vid, quantity: qty }) });
          })
          .then(function () { return fetch("/cart/prepare_shipping_rates.json?" + addr, { method: "POST", headers: { Accept: "application/json" } }); })
          .then(function () { return poll(addr, 7); })
          .then(function (rates) { return restore().then(function () { return rates; }); });
      })
      .then(renderRates)
      .catch(function () {
        restore();
        result.innerHTML = '<p class="ship-calc__err">Não foi possível calcular agora. Tente de novo.</p>';
      });
  }

  /* A11y: rotula o botão flutuante do WhatsApp (o app injeta um <a> sem nome acessível, e tarde) */
  function setupA11yPatches() {
    var tries = 0;
    (function label() {
      document.querySelectorAll('.bz__widget_btn > a:not([aria-label])').forEach(function (a) {
        a.setAttribute("aria-label", "Falar com a Star2Go no WhatsApp");
      });
      if (++tries < 6) setTimeout(label, 2000);
    })();
  }

  ready(function () {
    setupMobileMenu();
    setupAudienceToggle();
    setupHeaderCompress();
    setupPredictiveSearch();
    setupReveal();
    setupQuoteForm();
    setupCart();
    setupGallery();
    setupPdpAddbar();
    setupPdpOptions();
    setupHotspots();
    setupCollectionImageCarousel();
    setupAnnouncementBar();
    setupShippingCalc();
    setupA11yPatches();
    setupB2BPopupBlock();
  });

  /* Páginas B2B: sinaliza ao Kovyo que não deve abrir popup e, como rede de segurança,
     remove o popup se ele for injetado (o runtime do app ainda não lê o sinal). */
  function setupB2BPopupBlock() {
    if (document.body.getAttribute("data-mode") !== "b2b") return;
    window.KOVYO_POPUP_DISABLED = true;
    document.documentElement.setAttribute("data-kovyo-popup", "off");
    var kill = function () {
      document.querySelectorAll(".kv-content-col, [class*='kv-popup']").forEach(function (el) {
        var top = el, n = el;
        while (n && n !== document.body) {
          if (getComputedStyle(n).position === "fixed") top = n;
          n = n.parentElement;
        }
        top.remove();
      });
    };
    kill();
    new MutationObserver(kill).observe(document.body, { childList: true, subtree: true });
  }

  // Editor da Shopify: ao recarregar uma seção, religa os comportamentos (idempotente)
  document.addEventListener("shopify:section:load", function () {
    setupHotspots();
    setupCollectionImageCarousel();
    setupAnnouncementBar();
  });

  window.S2G = { setHomeMode: setHomeMode };
})();
